// Package Imports
import { Injectable } from '@angular/core';
import { AutoResume, DocumentInterruptSource, Idle } from '@ng-idle/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

// Components
import { MessageBoxModalComponent } from '../../components/message-box-modal/message-box-modal.component';

// Models
import { Message } from '../../models';

// Services
import { AppConfigService } from '../../services/app-config/app-config.service';
import { ResourceService } from '../../services/resource/resource.service';

@Injectable({
  providedIn: 'root'
})
export class IdleSessionService {
  private idleTime: number;
  private timeout: number;
  private timeoutMessage = new Message();
  private bsModalRef: BsModalRef;
  private resources: any;

  constructor(private readonly resourceService: ResourceService,
              private readonly appConfigService: AppConfigService,
              private readonly modalService: BsModalService,
              private readonly idleTimer: Idle) {
    this.resourceService.getDictionary('app').subscribe(r => this.resources = r.app.idleTimeout);
  }

  // PortalTimeout is in minutes, settings need to be in seconds. 5 minutes is the default.
  setupIdleTimeout(portalTimeout: number, logout: () => void) {
    if (portalTimeout == null || portalTimeout === 0 || portalTimeout > this.appConfigService.getData('idleTimeout')) {
      this.idleTime = 300; // 5 minutes
      this.timeout = 300; // 5 minutes
    }
    else {
      if (portalTimeout <= this.appConfigService.getData('idleTimeout')) {
        this.idleTime = 60; // 1 minute
        this.timeout = portalTimeout * 60; // Minutes to seconds
      }
      else {
        this.idleTime = 300; // 5 minutes
        this.timeout = 300; // 5 minutes
      }
    }

    this.idleTimer.setInterrupts([new DocumentInterruptSource(this.appConfigService.getData('idleInterrupt'))]);
    this.idleTimer.setAutoResume(AutoResume.notIdle);
    this.idleTimer.setIdle(this.idleTime);
    this.idleTimer.setTimeout(this.timeout);
    this.idleTimer.onTimeout.subscribe(() => logout());
    this.idleTimer.onIdleStart.subscribe(() => this.displayTimeout(logout));
    this.idleTimer.onTimeoutWarning.subscribe(countDown => this.timeoutMessage.text =
        this.resources.idleMessage.replace('<X>', moment.utc(countDown * 1000).format('m:ss')));

    this.reset();
  }

  reset() {
    this.idleTimer.watch();
  }

  private displayTimeout(logout: () => void) {
    this.timeoutMessage.title = 'Session Timeout';
    this.timeoutMessage.showCloseButtonX = false;
    this.timeoutMessage.showCloseButton = true;
    this.timeoutMessage.showOkButton = true;
    this.timeoutMessage.okButtonText = 'Yes';
    this.timeoutMessage.closeButtonText = 'No';

    this.bsModalRef = this.modalService.show(MessageBoxModalComponent,
                                             { backdrop: true, keyboard: false, ignoreBackdropClick: true, class: 'message-box' });
    this.bsModalRef.content.message = this.timeoutMessage;
    this.bsModalRef.content.confirmFn = () => this.reset();
    this.bsModalRef.content.closeFn = () => logout();
  }
}
